import type { PersonCard } from '../api/types';
import { LOOKING_FOR_LABELS } from '../api/types';

interface Props {
  person: PersonCard;
  onOpen?: (id: number) => void;
}

function initials(name: string): string {
  return name
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('');
}

export function PersonCardView({ person, onOpen }: Props) {
  const subtitle = [person.occupation, person.company].filter(Boolean).join(' · ');

  return (
    <button
      className="person"
      onClick={() => onOpen?.(person.user_id)}
      disabled={!onOpen}
    >
      {person.photo_url ? (
        <img className="person__avatar" src={person.photo_url} alt="" loading="lazy" />
      ) : (
        <div className="person__avatar person__avatar--letters">
          {initials(person.full_name)}
        </div>
      )}

      <div className="person__text">
        <div className="person__name">{person.full_name}</div>
        {/* Занятие — то, ради чего список участников вообще существует. */}
        {subtitle && <div className="person__role">{subtitle}</div>}
        {/* Факт идёт без подписи «интересный факт»: подпись превратила бы
            живую строку в поле анкеты. Он и так читается как реплика. */}
        {person.fun_fact && <div className="person__fact">{person.fun_fact}</div>}
        {person.looking_for_tags.length > 0 && (
          <div className="person__tags">
            {person.looking_for_tags.map((tag) => (
              <span key={tag} className="tag">
                {LOOKING_FOR_LABELS[tag] ?? tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </button>
  );
}
